// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { inventoryController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfAudio } from "../../framework/tgfAudio";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfEffects } from "../../framework/tgfEffects";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings, PowerUpSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { AngryAnalytics } from "../Analytics/Analytics";
import { s_bg_placeholder, s_black_square, s_daily_reward_panel, s_daily_reward_selection_box, s_btn_green, s_daily_reward_paper_sheet_torn, s_daily_reward_paper_sheet, s_daily_reward_powerup_icon, s_daily_reward_blue_bg_terence, s_bird_terrence } from "../AssetDefinitions/ImageDefinitions";
import { DailyRewardManager } from "../DailyRewardManager";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
import { PowerupRewardDialog } from "./PowerupRewardDialog";
import { TerenceRewardDialog } from "./TerenceRewardDialog";
tgfSettings.dialogDefaults.DailyRewardDialog = {
    width: 800,
    height: 550,
    font: DialogSettings.textFont,
    smallFont: DialogSettings.textFontSmall,
    buttonFont: DialogSettings.buttonFont,
    counterFont: DialogSettings.powerupCountFont,
    maxPapers: 5,
    components: [],
    rotationsPerSecond: 0.1,
    boxElastic: { effect: tgfEffects.popElastic, duration: 4, startScaleX: 1, endScaleX: 1.25, startScaleY: 1, endScaleY: 0.9, easeArgument: 1, name: "elastic" },
};
export var DailyRewardDialog = function (properties) {
    "use strict";
    this.name = "DailyRewardDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.DailyRewardDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
};
// Inherit the base dialog
tgfDialogs.inherit(DailyRewardDialog, DialogBase);
DailyRewardDialog.prototype.doPrepare = function () {
    "use strict";
    AngryAnalytics.reportScreen("dailyreward");
    SoundManager.playEffect(SoundManager.MUSIC_STATE.LOBBY, SoundManager.MusicCollection, 0, true);
    this.background = new ComponentPicture({
        image: s_bg_placeholder,
        xScale: 2,
        yScale: 2
    });
    this.addComponent(this.background);
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.panel = new ComponentPicture({
        image: s_daily_reward_panel,
        y: -10
    });
    this.transparentBlack.addComponent(this.panel);
    this.headerLabel = new ComponentLabel({
        text: tgfDictionary.getText("DAILY_REWARD_HEADER"),
        y: -270,
        font: this.buttonFont,
        angle: -Math.PI / 36
    });
    this.panel.addComponent(this.headerLabel);
    this.mainLabel = new ComponentLabel({
        text: tgfDictionary.getText("DAILY_REWARD_1_TEXT"),
        y: -175,
        font: this.font
    });
    this.panel.addComponent(this.mainLabel);
    var day = Math.floor(DailyRewardManager.getCurrentDay());
    this.papers = [];
    for (var i = 0; i < this.maxPapers; i++) {
        var x = -this.width / 2 + i * this.width / 5 + 60;
        var reward = DailyRewardManager.getCurrentReward(i);
        var isTorn = i < day;
        var isCurrent = i === day;
        this.papers[i] = this.createRewardImage(x, 0, isTorn, reward, isCurrent, i + 1);
        this.panel.addComponent(this.papers[i]);
    }
    this.selectionBox = new ComponentButton({
        image: s_daily_reward_selection_box,
        x: -this.width / 2 + day * this.width / 5 + 60 + s_daily_reward_selection_box.width / 2,
        y: 20 + s_daily_reward_selection_box.height / 2,
        onClick: this.onClaimReward.bind(this),
        effects: [{ effect: "show", duration: 2 }, this.boxElastic, { effect: "show", duration: 99999999 }],
        onSubEffectEnd: function (component, effect) {
            if (effect.name === "elastic") {
                component.startSubEffect(0);
            }
        },
    });
    this.panel.addComponent(this.selectionBox);
    this.claimButton = new ComponentButton({
        text: tgfDictionary.getText("BTN_DAILY_REWARD"),
        fontUp: this.buttonFont,
        image: s_btn_green,
        y: 265,
        onClick: this.onClaimReward.bind(this)
    });
    this.panel.addComponent(this.claimButton);
};
DailyRewardDialog.prototype.createRewardImage = function (x, y, isTorn, reward, isCurrent, day) {
    var dayLabelYOffset = -70;
    var dayFont = JSON.parse(JSON.stringify(this.font));
    dayFont.shadow.active = false;
    if (isCurrent) {
        dayFont.fillColor = "0x4286f4";
    }
    else {
        dayFont.fillColor = "0xfc8e20";
    }
    var paper;
    if (isTorn) {
        paper = new ComponentPicture({
            image: s_daily_reward_paper_sheet_torn,
            x: x,
            y: y,
        });
        var label = new ComponentLabel({
            text: tgfDictionary.getText("DAILY_REWARD_2_TEXT") + " " + day,
            y: dayLabelYOffset,
            font: dayFont,
            width: 140
        });
        paper.addComponent(label);
    }
    else {
        paper = new ComponentPicture({
            image: s_daily_reward_paper_sheet,
            x: x,
            y: y,
        });
        var label = new ComponentLabel({
            text: tgfDictionary.getText("DAILY_REWARD_2_TEXT") + " " + day,
            y: dayLabelYOffset,
            font: dayFont,
            width: 140
        });
        paper.addComponent(label);
        var rewardYOffset = 25;
        switch (reward) {
            case DailyRewardManager.REWARD_TYPES.POWERUP:
                var image = new ComponentPicture({
                    image: s_daily_reward_powerup_icon,
                    y: rewardYOffset
                });
                paper.addComponent(image);
                var powerupCounter = new ComponentLabel({
                    text: "3",
                    x: 27,
                    y: 24,
                    font: this.counterFont
                });
                image.addComponent(powerupCounter);
                break;
            case DailyRewardManager.REWARD_TYPES.TERENCE:
                this.terenceBgImage = new ComponentPicture({
                    image: s_daily_reward_blue_bg_terence,
                    y: rewardYOffset
                });
                paper.addComponent(this.terenceBgImage);
                var terence = new ComponentPicture({
                    image: s_bird_terrence,
                    angle: -Math.PI / 30,
                    y: -10
                });
                this.terenceBgImage.addComponent(terence);
                break;
        }
    }
    return paper;
};
DailyRewardDialog.prototype.onClaimReward = function () {
    DailyRewardManager.onClaimReward();
    var rewardType = DailyRewardManager.getCurrentReward();
    var onCloseReward = this.onClose;
    switch (rewardType) {
        case DailyRewardManager.REWARD_TYPES.POWERUP:
            var rewardScreen = new PowerupRewardDialog({
                origin: "dailyreward",
                onClose: onCloseReward,
                reverseAnimation: inventoryController.getFilledPowerUps() == PowerUpSettings.maxSlotAmount,
                includeBackground: true
            });
            rewardScreen.show();
            inventoryController.unlockAllPowerUps();
            rewardScreen.reloadPowerups(true);
            break;
        case DailyRewardManager.REWARD_TYPES.TERENCE:
            var rewardScreen = new TerenceRewardDialog({
                onClose: onCloseReward,
                includeBackground: true
            });
            rewardScreen.show();
            DailyRewardManager.startTerenceTimer();
    }
    tgfAudio.stop("music");
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    SoundManager.playEffect(SoundManager.MUSIC_STATE.STINGER_WIN, SoundManager.MusicCollection, 0, false);
    this.onClose = null;
    this.close();
};
DailyRewardDialog.prototype.close = function () {
    this.hide();
    this.free();
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (this.onClose) {
        this.onClose();
    }
};
DailyRewardDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
DailyRewardDialog.prototype.handleEndStep = function (timePassed) {
    DailyRewardDialog.uber.handleEndStep.call(this, timePassed);
    var angleChange = timePassed / 1000 * (Math.PI * 2) * this.rotationsPerSecond;
    var newAngle = this.terenceBgImage.angle + angleChange;
    this.terenceBgImage.setAngle(newAngle);
};
